import api from '@/api/Api'
import Dataset from '@models/dataset/dataset'

export const state = {
  dataSets: []
}

export const getters = {
  dataSets (state) {
    return state.dataSets
  }
}

export const mutations = {
  SET_DATASET (state, newValue) {
    state.dataSets = newValue
  },
  UPDATE_TRAINING_DATASET (state, id) {
    let index = state.dataSets.findIndex(val => val.id === id)
    state.dataSets.splice(index, 1)
  }
}
export const actions = {
  getDataset ({ commit, state, rootState }, id) {
    return api.getListDataset(id).then((response) => {
      let dataSets = response.data.data.map(val => new Dataset(val))
      commit('SET_DATASET', dataSets)
      return response
    })
  },
  getDetailDataset ({commit, state, rootState}, form) {
    return api.getDetailDataset(form).then((response) => {
      return response
    })
  },
  deleteDataset ({dispatch, commit, state, rootState}, form) {
    return api.deleteDataset(form).then((response) => {
      commit('UPDATE_TRAINING_DATASET', form.id)
      dispatch('getDataset', form.workspaceId)
      return response
    })
  },
  updateDataset ({commit, state, rootState}, form) {
    return api.updateDataset(form).then((response) => {
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/dataset.js